import $ from 'jquery';

import 'popper.js';
import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
import 'bootstrap/js/dist/tooltip';

if (!window.HTMLPictureElement) {
    import('picturefill');
}

let _config = window['_config'] || {};

window.app = window.app || {};
window.app.modules =  window.app.modules || {};

let app = window.app;

import initModulesInScope from "@elements/init-modules-in-scope";
app.initModules = function ($scope) {
    console.warn('\'app.initModules\' is going to be deprecated and should not be used anymore. Please import and use \'initModulesInScope\' from \'./scripts/initModulesInScope\' instead.');
    initModulesInScope($scope);
};

$.loadScript = function (url) {
    console.warn('\'$.loadScript\' is going to be deprecated and should not be used anymore. Please use \'import\' for local files or import and use \'loadScript\' for external resources.');

    return import('@elements/load-script').then(function (loadScript) {
        return loadScript.default(url);
    });
};
import './scripts/common';

/**********************************
 *
 *      Project Stuff
 *
 * ********************************/

import * as productGrid from '@elements/product-grid';
app.productGrid = productGrid.init;
app.modules.productGrid = productGrid.initInScope;

import * as productGridQuickFilter from '@elements/product-grid/quick-filter';
app.modules.productGridQuickFilter = productGridQuickFilter.initInScope;

import * as rangeSlider from './scripts/range-slider';
app.modules.rangeSlider = rangeSlider.initInScope;

import * as smoothScroll from '@elements/smooth-scroll';
let options = {
    offset: 120
};

import * as numberSpinner from '@elements/number-spinner';
app.modules.numberSpinner = numberSpinner.initInScope;

smoothScroll.init(options, {});
smoothScroll.initInScope();

import * as submitFormOnChange from './scripts/submit-form-on-change';
app.modules.submitFormOnChange = submitFormOnChange.initInScope;

import * as toggleToListTooltip from './scripts/toggle-to-list-tooltip';
app.modules.toggleToListTooltip = toggleToListTooltip.createTooltipInitInScope;

import * as ajaxModal from './scripts/ajax-modal';
import * as swiper from "./scripts/swiper";
app.modules.ajaxModal = ajaxModal.initInScope;

import * as showMore from './scripts/show-more';
app.modules.showMore = showMore.initInScope;

app.modules.productContentTeaserSwiper = swiper.createInitInScope({
        sliderContainer: '.js-swiper-product-content-teaser',
        slider: '.js-swiper__slider',
        sliderScrollbar: '.js-swiper__scrollbar',
        sliderPrev: '.js-swiper__prev',
        sliderNex: '.js-swiper__next'
    },
    {
        loop: false,
        slidesPerView: 2,
        spaceBetween: 20,
        scrollbar: {
            findElement: $swiperContainer => $swiperContainer.find('.js-swiper__scrollbar'),
            draggable: true,
        },
        navigation: {
            findNextElement: $swiperContainer => $swiperContainer.find('.js-swiper__next'),
            findPrevElement: $swiperContainer => $swiperContainer.find('.js-swiper__prev'),
        },
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: 4,
                spaceBetween: 40
            }
        }
    });

app.modules.contentTeaserSwiper = swiper.createInitInScope({
        sliderContainer: '.js-swiper-content-teaser',
        slider: '.js-swiper__slider',
        sliderScrollbar: '.js-swiper__scrollbar',
        sliderPrev: '.js-swiper__prev',
        sliderNex: '.js-swiper__next'
    },
    {
        loop: false,
        slidesPerView: 1.2,
        spaceBetween: 20,
        scrollbar: {
            findElement: $swiperContainer => $swiperContainer.find('.js-swiper__scrollbar'),
            draggable: true,
        },
        navigation: {
            findNextElement: $swiperContainer => $swiperContainer.find('.js-swiper__next'),
            findPrevElement: $swiperContainer => $swiperContainer.find('.js-swiper__prev'),
        },
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: 3,
                spaceBetween: 40,
                allowTouchMove:false
            }
        }
    });


(function( $ ){
    "use strict";

    /* -> _config._preload = Load this functions first */
    if (_config['_preload']) {
        $.each( _config['_preload'], function( _key, _val ){
            if( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ){
                window.app[_key]();
            }
        });
    }

    /* -> _config = Load all others (not _preload and _reload) */
    $.each( _config, function( _key, _val ){
        // console.log('key',_key)
        // console.log('val',_val)
        if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' && _key != '_reload' && _key != '_preload' ) ){
            window.app[_key]();
        }
    });

    /* -> _config._reload = Load the ajaxInclued and others after the rest */
    if (_config['_reload']) {
        $.each( _config['_reload'], function( _key, _val ){
            if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ) ){
                window.app[_key]();
            }
        });
    }

    initModulesInScope();
})($);